export default {
  kr: {
    code: 'KR',
    name: 'Korea, Republic of'
  }
}
